import React, { useContext, useEffect, useState } from "react";
import { Context } from "../context/Context";
import AddRoom from "./AddRoom";
import { Link, useNavigate } from "react-router-dom";
import { AllEquipments, AllRoom, DeleteRoom } from "../api/api";

const PlanningMenu = () => {
  const navigate = useNavigate();
  const { page, setPage } = useContext(Context);

  return (
    <>
      <div className="planning-list d-none d-lg-block">
        <ul className="list-group">
          <li className="list-group-item">
            <div>
              <Link
                to="/planning/scenario-list"
                className={
                  page.slug === "planning/scenario" ||
                  page.slug == "planning/scenario-list"
                    ? "text-secondary active"
                    : "text-secondary"
                }
                onClick={() => {
                  setPage({
                    name: "سناریو",
                    slug: "planning/scenario",
                  });
                }}
              >
                سناریو
              </Link>
            </div>
          </li>
          <li className="list-group-item">
            <div>
              <Link
                to="/planning"
                className={
                  page.slug === "planning/schedule" || page.slug === "planning"
                    ? "text-secondary active"
                    : "text-secondary"
                }
                onClick={() => {
                  setPage({
                    name: "زمان بندی",
                    slug: "planning/schedule",
                  });
                }}
              >
                زمان بندی
              </Link>
            </div>
          </li>
        </ul>
      </div>
      <ul className="menu-inner d-flex flex-row overflow-scroll d-lg-none">
        <li
          className={
            page.slug === "planning/scenario" ||
            page.slug == "planning/scenario-list"
              ? "menu-item d-lg-none active"
              : "menu-item d-lg-none"
          }
          style={{ fontSize: "0.896rem" }}
        >
          <Link
            to="/planning/scenario-list"
            className="menu-link"
            onClick={() => {
              setPage({
                name: "سناریو",
                slug: "planning/scenario",
              });
            }}
          >
            سناریو
          </Link>
        </li>

        <li
          className={
            page.slug === "planning/schedule" || page.slug === "planning"
              ? "menu-item d-lg-none active"
              : "menu-item d-lg-none"
          }
          style={{ fontSize: "0.896rem" }}
        >
          <Link
            to="/planning"
            className="menu-link"
            onClick={() => {
              setPage({
                name: "زمان بندی",
                slug: "planning/schedule",
              });
            }}
          >
            زمان بندی
          </Link>
        </li>
      </ul>
    </>
  );
};

export default PlanningMenu;
